import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('payment-methods' + params)
	},
	remove(category_id) {
		return http.delete('payment-methods/' + category_id)
	},
	createOrUpdate(model) {
		if(model.id) {
			return http.put('payment-methods/' + model.id, model)
		} else {
			return http.post('payment-methods', model)
		}
	}
}